module.exports = "/assets/images/293aea0902a7f624e7526913e29303fb.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_tick.svg
// module id = r5UY
// module chunks = 0